import EmailStaticContent from './EmailStaticContent';
export default EmailStaticContent;